module.exports = __webpack_public_path__ + "img/3.8ea8c728.png";